{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              183.40228929742318,
              -15.129863598691813
            ],
            [
              155.67756359915154,
              -0.19672630311190176
            ],
            [
              140.81306797992897,
              -0.5621208264181234
            ],
            [
              141.1724315265957,
              -10.372388011412212
            ],
            [
              131.92713007850278,
              -10.066754561153019
            ],
            [
              125.48873840786291,
              -12.235911629402807
            ],
            [
              109.80420361922654,
              -17.42984557174435
            ],
            [
              109.05456809037463,
              -34.29001301534662
            ],
            [
              133.403803855844,
              -40.93093107251049
            ],
            [
              169.82119951472322,
              -53.42331086058456
            ],
            [
              186.16359573840452,
              -40.370025834000096
            ],
            [
              183.40228929742318,
              -15.129863598691813
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}